<template>
    <div class="px-4 md:px-8">
        <AppHead title="10xTravel+" />

        <!-- Show membership dashboard if user has active subscription (including shared wallet) -->
        <MembershipDashboard
            v-if="hasActiveSubscription"
            :circle-url="page.props.circleUrl"
        />

        <!-- Show Upgrade page if no active subscription -->
        <Upgrade v-else />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import AppHead from '@/Partials/AppHead.vue';
import MembershipDashboard from '@/components/travel-plus/membership-dashboard.vue';
import Upgrade from '@/Pages/TravelPlus/Upgrade.vue';

const props = defineProps({
    calendlyConfig: {
        type: Object,
        default: () => ({}),
    },
});

const page = usePage();

const hasActiveSubscription = computed(() => {
    return page.props.userData?.is_subscribed === true;
});
</script>
